// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upDLt{position:relative;width:87%;margin:0 auto;min-height:100vh}._3u1ny{padding-top:3rem;font-size:48px;font-size:3rem;font-weight:500;line-height:60px;line-height:3.75rem;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}@media(max-width:767px){._3u1ny{font-size:2rem;line-height:2.5rem}}.b73Bv{margin:1.5rem 0 2rem;max-width:513px;font-size:18px;font-size:1.125rem;font-weight:400;line-height:29px;line-height:1.8125rem;font-family:var(--base-font)}._22dgx{position:relative}.aVjO2{width:100%}._2nDy5{position:fixed;width:87%;padding-top:3rem;height:100%;bottom:0;left:0;right:0;margin:auto}@media(min-width:1440px){._2nDy5{max-width:78rem}}._1kovR{height:313px;height:19.5625rem;position:relative}.EdknI{position:absolute;will-change:opacity,transform;max-width:100%;border-radius:24px}", ""]);
// Exports
exports.locals = {
	"root": "upDLt",
	"title": "_3u1ny",
	"description": "b73Bv",
	"container": "_22dgx",
	"wrapper": "aVjO2",
	"groupActive": "_2nDy5",
	"elementContainer": "_1kovR",
	"fullImage": "EdknI"
};
module.exports = exports;
